import Homepage from "pages/Homepage";

export default function HomePage() {
    return <Homepage />;
}
